import request from './plugins/request'

export let timestampToTime = (time) => {
    var date = new Date(time * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear();
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
    var D = date.getDate()+1 <= 10 ? '0'+date.getDate() : date.getDate();
    return {
        Y,M,D
    }
}
// 分类
export let Article = (params = {}, id = -1) => {
    let url = 'https://api.bernouly.com:82/api/article';
    // let url = 'http://127.0.0.1:82/api/article';
    url = id >= 0 ? url + '/' + id : url;
    return request({
        url,
        params,
        method: 'get'
    })
}

export let ArChildren = (params = {}) => {
    let url = 'https://api.bernouly.com:82/api/category/children';
    // let url = 'http://127.0.0.1:82/api/category/children';
    return request({
        url,
        params,
        method: 'get'
    })
}

export let ApiMessage = (params = {}) => {
    let url = 'https://api.bernouly.com:82/api/message';
    // let url = 'http://127.0.0.1:82/api/message';
    return request({
        url,
        params,
        method: 'post'
    })
}

//新增接口

export let Serchdata = (params = {}) => {
    let url = 'http://39.106.230.10:82/selExamScore';
    return request({
        url,
        params,
        method: 'get'
    })
}
